import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=6931afd8&"
import script from "./Metadata.vue?vue&type=script&lang=js&"
export * from "./Metadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports